<template>
    <section class="home-education">
      <div class="container section-value-props section-education hidden">
        <div class="section-header">
          <!-- <span class="subheading">{{$t("edu.title")}}</span> -->
          <h2 class="heading-secondary">What Makes INVRS Different.</h2>
        </div>
        <div class="grid grid--4-cols">
           <div class="value-box hidden">
          <img src="/assets/invrs-education4.png" class="value-icon" />
          <h3 class="heading-tertiary">{{$t("edu.trust")}}</h3>
          <p class="value-description">
            Built by a CFA/CPA — not influencers, not hype merchants. Just depth in business, economics, and investing.
          </p>
        </div>
        <div class="value-box hidden">
          <img src="/assets/invrs-education2.png" class="value-icon" />
          <h3 class="heading-tertiary" >Learn By Doing.</h3>
          <p class="value-description">Real market data and tools — with new ones always in development, so as your skills grow, we keep up.
          </p>
        </div>
        <div class="value-box hidden">
          <img src="/assets/invrs-education1.png" class="value-icon" />
          <h3 class="heading-tertiary">Gamified Challenges</h3>
          <p class="value-description" >FinTrivia and Learn2Earn investment competitions keep you engaged and leveling up.
          
          </p>
        </div>
        
        <div class="value-box hidden">
          <img src="/assets/invrs-education3.png" class="value-icon" />
          <h3 class="heading-tertiary">{{$t("edu.support")}}</h3>
          <p class="value-description">
            
            Perfect for beginners. Got questions? We’ve got answers.
          </p>
        </div>
       
      </div>
      </div>
       <button @click="goToSignup" style="margin-left:auto;margin-right:auto;margin-top:2rem;">
            <span>Sign Up Now &rarr;</span>
          
          </button>
    </section>
  </template>
  
  <script>
  import { SIGNUP_URL } from "../../config.js";

export default {
  data() {
    return {
      valueProps: [],
      obsOptionsValueProps: {
        root: null,
        threshold: 0.3,
      },
      obsOptionsSection: {
        root: null,
        threshold: 0.15,
      },
      section: "",
    };
  },
  mounted() {
    this.valueProps = document.querySelectorAll(".home-education .value-box");
    this.section = document.querySelector(".home-education .section-value-props");
    const valuePropsObserver = new IntersectionObserver(
      this.revealValueProps,
      this.obsOptionsValueProps
    );
    const sectionObserver = new IntersectionObserver(
      this.revealSection,
      this.obsOptionsSection
    );
    valuePropsObserver.observe(this.section);
    sectionObserver.observe(this.section);
  },
  methods: {
     goToSignup() {
      window.location.href = SIGNUP_URL;
    },
    revealValueProps(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.valueProps.forEach((v, i) => {
            setTimeout(() => v.classList.remove("hidden"), i * 100);
          });
        }
      });
    },
    revealSection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.section.classList.remove("hidden");
        }
      });
    },
  },
};
</script>
  
<style scoped>

  .heading-secondary {
    font-size: 3rem;
}
section {
  padding: 5rem 0;
  background: linear-gradient(
    180deg,
    #f2f4fa 32.54%,
    rgba(242, 244, 250, 0) 100%
  );
  position: relative;
}

::v-deep(.section-education) {
  max-width: 180rem;
}

.section-value-props {
  transition: all 0.3s ease-in;
}

.value-description {
  font-size: 1.8rem;
  line-height: 2.6rem;
}

.value-icon {
  margin-bottom: 1.6rem;
  width: 8.6rem;
  height: 9.2rem;
}

.section-header {
  display: flex;
  flex-direction: column;
}

.value-box {
  transition: all 0.3s ease-in;
}

.hidden {
  transform: translateY(4.8rem);
  opacity: 0;
}

.earth-icon {
  position: absolute;
  z-index: 99;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
.earth-icon {
    height: 80%;
  }
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
.earth-icon {
    height: 60%;
  }
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
.earth-icon {
    height: 45%;
  }

  p {
    width: 100%;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
.value-icon {
  margin-bottom: 1.6rem;
  width: 6.4rem;
  height:6.4rem;
}

.earth-icon {
    height: 40%;
  }
}

/* **************************** */
/* BELOW 432px (mobile) */
/* **************************** */
@media (max-width: 27em) {
.earth-icon {
    height: 35%;
  }
}

button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 5px 10px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}
</style>
